export default __webpack_public_path__ + "device_doorbell_4.ff35926f.png";